<div class="address-modal__body">
    <vsf-address-form
        [address]="address"
        [availableCountries]="availableCountries$ | async"
        [hideCompany]="hideCompany"
    ></vsf-address-form>
</div>

<ng-template vsfDialogTitle>
    <span class="text-lg font-semibold text-gray-900">{{ title }}</span>
</ng-template>

<ng-template vsfDialogButtons>
    <div class="address-modal__actions">
        <button
            type="button"
            class="address-modal__btn address-modal__btn--cancel"
            (click)="cancel()"
            aria-label="Cancel address changes"
        >
            Cancel
        </button>
        <button
            type="button"
            class="address-modal__btn address-modal__btn--save"
            [disabled]="saveDisabled"
            (click)="save()"
            aria-label="Save address"
        >
            Save
        </button>
    </div>
</ng-template>
